import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Ticket, TicketAggregate } from 'src/app/models/ticket/ticket.model';

@Component({
  selector: 'app-ticket-top',
  templateUrl: 'ticket-top.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TicketTopComponent {
  @Input() tickets: Ticket[];

  @Input() isLoading: boolean = false;

  @Input() aggregate: TicketAggregate | null = null;
}
